import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Welcome from './Welcome';
import Location from '../options/Location';
import PlaceAlerts from '../options/PlaceAlerts';
import FindLoved from '../options/FindLoved';
import ShareFlight from '../options/ShareFlight';
import EmergencyAlerts from '../options/EmergencyAlerts';
import ChooseTarget from '../family/ChooseTarget';
import CreatePlace from '../family/CreatePlace';
import PlansScreen from '../plans/PlansScreen';
import UIButton from '../../UI/UIButton';
import { selectIfCheckoutVisited } from '../plans/plansSlice';

const FeaturesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 24px;
  padding: 0 24px;

  & > * {
    width: 100%;
    height: auto;
    padding: 0;

    @media (min-width: 1280px) {
      width: 33%;
      flex-direction: column-reverse;
      margin-top: 64px;
    }
  }
`;

const OptionsWrapper = styled.div`
  & > * {
    height: auto;
  }
`;

const OnePageLanding = (props) => {
  const { t } = useTranslation();
  const isCheckoutVisited = useSelector(selectIfCheckoutVisited);

  const smoothScrollTo = (selector) => {
    const scrollLink =  document.createElement('a');
    scrollLink.href = selector;
    scrollLink.click();
  };

  useEffect(() => {
    if (isCheckoutVisited) {
      setTimeout(() => smoothScrollTo('#plans-wrapper'), 100);
    }
  }, [isCheckoutVisited]);

  return (
    <>
      <Welcome {...props} onePage smoothScrollTo={smoothScrollTo} />
      <FeaturesWrapper id={'features-wrapper'}>
        <Location {...props} onePage/>
        <PlaceAlerts {...props} onePage/>
        <FindLoved {...props} onePage/>
        <ShareFlight {...props} onePage/>
        <EmergencyAlerts {...props} onePage/>
      </FeaturesWrapper>
      <UIButton onClick={() => smoothScrollTo('#options-wrapper')}>{t('start_tracking')}</UIButton>
      <OptionsWrapper id={'options-wrapper'}>
        <ChooseTarget {...props} onePage/>
        <CreatePlace {...props} onePage/>
      </OptionsWrapper>
      <PlansScreen {...props} onePage/>
    </>
  );
};

export default OnePageLanding
